import { Inbox } from 'lucide-react'
import { useI18n } from '../i18n'

export function EmptyState({ title, detail }: { title: string; detail?: string }) {
  const { t } = useI18n()
  return <div className="flex min-h-[16rem] flex-col items-center justify-center rounded-xl border border-dashed bg-muted/30 p-8 text-center">
    <div className="mb-4 rounded-full bg-muted p-4 text-muted-foreground"><Inbox size={24} /></div>
    <p className="font-medium text-foreground/80">{t(title)}</p>
    {detail && <p className="mt-1.5 text-sm text-muted-foreground max-w-xs">{t(detail)}</p>}
  </div>
}
